import React, {useEffect, useState} from "react";

const NestedAccordionIcon = (props) => {
  const [state, setState] = useState({
    color: `rgba(${props.iconColor.r},${props.iconColor.g},${props.iconColor.b},${props.iconColor.a})`,
  });
  useEffect(() => {
    setState({
      color: `rgba(${props.iconColor.r},${props.iconColor.g},${props.iconColor.b},${props.iconColor.a})`,
    });
  },[props.iconColor])

  return (
    <>
      {props.iconStyle == "plus" ? (
        props.itemOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="2"
            viewBox="0 0 12 2"
          >
            <rect
              id="Rectangle_11_copy_3"
              data-name="Rectangle 11 copy 3"
              width="12"
              height="2"
              fill={state.color}
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.002"
            height="12"
            viewBox="0 0 12.002 12"
          >
            <path
              id="Union_14"
              data-name="Union 14"
              d="M-11812-7931v-5h-5v-2h5v-5h2v5h5v2h-5v5Z"
              transform="translate(11817.001 7943)"
              fill={state.color}
            />
          </svg>
        )
      ) : props.iconStyle == "arrow" ? (
        props.itemOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.002"
            height="12"
            viewBox="0 0 512 512"
            fill={state.color}
          >
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.002"
            height="12"
            viewBox="0 0 512 512"
            fill={state.color}
          >
            <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
          </svg>
        )
      ) : props.itemOpen ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12.002"
          height="12"
          viewBox="0 0 512 512"
          fill={state.color}
        >
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12.002"
          height="12"
          viewBox="0 0 512 512"
          fill={state.color}
        >
          <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
        </svg>
      )}
    </>
  );
};

export default NestedAccordionIcon;
